export type IncidentWorkspaceNavItem = {
  id: string;
  label: string;
  to: string;
  icon: string;
  end?: boolean;
  /** Navigates to dashboard with openTab; caller should show the map. */
  opensMapTab?: boolean;
};

export type IncidentWorkspaceNavFlags = {
  incidentId: string;
  isEscalated: boolean;
  myWorkspacePath: string | null;
  hwcg: boolean;
  streamlinePlatform: boolean;
  /** Same gate as Tasks Apply Plan: HWCG or FOC requirements. */
  showApplyPlan: boolean;
};

/** Primary incident hamburger rows (Position Workspaces stay outside this list). */
export function getIncidentWorkspaceNavItems(
  flags: IncidentWorkspaceNavFlags
): IncidentWorkspaceNavItem[] {
  const { incidentId } = flags;
  const base = `/iap/${incidentId}`;
  const items: IncidentWorkspaceNavItem[] = [
    {
      id: 'dashboard',
      label: flags.isEscalated ? 'Planning-P' : 'ICS-201 Workspace',
      to: `${base}/dashboard`,
      icon: flags.isEscalated ? 'dashboard' : 'description',
      end: true,
    },
  ];

  if (flags.myWorkspacePath) {
    items.push({
      id: 'my-workspaces',
      label: 'My Workspaces',
      to: flags.myWorkspacePath,
      icon: 'badge',
    });
  }

  items.push(
    {
      id: 'calendar',
      label: 'Calendar',
      to: `${base}/calendar`,
      icon: 'calendar_month',
    },
    {
      id: 'notifications',
      label: 'Notifications',
      to: `${base}/notifications`,
      icon: 'notifications',
    },
    {
      id: 'resources',
      label: 'Assets',
      to: `${base}/resources`,
      icon: 'package_2',
    },
    {
      id: 'roster',
      label: 'Incident Roster',
      to: `${base}/roster`,
      icon: 'people',
    },
    {
      id: 'actions',
      label: 'Tasks',
      to: `${base}/actions`,
      icon: 'checklist',
    }
  );

  if (flags.hwcg) {
    items.push({
      id: 'group-actions',
      label: 'Group Actions',
      to: `${base}/group-actions`,
      icon: 'campaign',
    });
  }

  if (flags.showApplyPlan) {
    items.push({
      id: 'apply-plan',
      label: 'Apply Plan',
      to: `${base}/apply-plan`,
      icon: 'library_books',
    });
  }

  if (!flags.streamlinePlatform) {
    items.push(
      {
        id: 'approved-forms',
        label: 'Approved ICS Forms',
        to: `${base}/approved-forms`,
        icon: 'fact_check',
      },
      {
        id: 'activity-logs',
        label: 'Activity Logs',
        to: `${base}/activity-logs`,
        icon: 'history',
      }
    );
  }

  items.push(
    {
      id: 'reports',
      label: 'Reports',
      to: `${base}/reports`,
      icon: 'flag',
    },
    {
      id: 'presentation',
      label: 'Presentation',
      to: `${base}/presentation`,
      icon: 'slideshow',
    },
    {
      id: 'notes',
      label: 'Notes',
      to: `${base}/notes`,
      icon: 'sticky_note_2',
    },
    {
      id: 'layers',
      label: 'Map Layers',
      to: `${base}/dashboard?openTab=Layers`,
      icon: 'layers',
      opensMapTab: true,
    },
    {
      id: 'events',
      label: 'Events',
      to: `${base}/dashboard?openTab=Events`,
      icon: 'cell_tower',
      opensMapTab: true,
    },
    {
      id: 'profile',
      label: 'Incident Profile',
      to: `${base}/profile`,
      icon: 'person',
    },
    {
      id: 'files',
      label: 'Files',
      to: `${base}/files`,
      icon: 'folder',
    },
    {
      id: 'settings',
      label: 'Settings',
      to: `${base}/settings`,
      icon: 'settings',
    }
  );

  return items;
}
